import { AxiosResponse } from 'axios'
import { ActiveUser, PrinterDetails, UserAccount } from '../../types'
import { IStratusService } from '../../lib/stratusService'
import { SessionData } from '../../lib/sessionData'
import { resolve, getMockFixtureOverride } from './mockHelpers'

const activeUserFixture = ({
  email = {
    value: 'user@email.com',
    verified: true
  },
  givenName = 'John',
  familyName = 'Smith',
  createdAt = new Date().toISOString()
} = {}): ActiveUser => ({
  email,
  givenName,
  familyName,
  createdAt
})

const userAccountFixture = ({
  resourceId = '12345678',
  regionId = 'US',
  type = 'BusinessTransactionalSMB'
} = {}): UserAccount => ({
  resourceId,
  regionId,
  type
})

const printerDetailsFixture = ({
  identity = {
    friendlyName: 'Printer Name',
    location: 'HP headquarters',
    deviceUuid: 'device-uuid-1'
  }
} = {}): PrinterDetails => ({
  identity
})

export class MockStratusService implements IStratusService {
  sessionData: SessionData
  defaultDelay: number

  constructor(sessionData: SessionData, defaultDelay = 0) {
    this.sessionData = sessionData
    this.defaultDelay = defaultDelay
  }

  getActiveUser(): Promise<AxiosResponse<ActiveUser>> {
    return resolve(
      {
        data: {
          ...activeUserFixture(),
          ...getMockFixtureOverride(this.sessionData, 'activeUser')
        },
        status: 200,
        statusText: 'ok',
        headers: {},
        config: {}
      },
      this.defaultDelay
    )
  }

  getUserAccount(): Promise<AxiosResponse<UserAccount>> {
    return resolve(
      {
        data: {
          ...userAccountFixture(),
          ...getMockFixtureOverride(this.sessionData, 'userAccount')
        },
        status: 200,
        statusText: 'ok',
        headers: {},
        config: {}
      },
      this.defaultDelay
    )
  }

  getPrinterDetails(): Promise<AxiosResponse<PrinterDetails[]>> {
    return resolve(
      {
        data: [
          {
            ...printerDetailsFixture(),
            ...getMockFixtureOverride(this.sessionData, 'printerDetails')
          }
        ],
        status: 200,
        statusText: 'ok',
        headers: {},
        config: {}
      },
      this.defaultDelay
    )
  }
}
